import { defineStore } from 'pinia';
import axios from 'axios';
import { API_URL, error } from '~/utils';

async function resetarSenha(cmd) {
  const response = await axios.post(
    `${API_URL}/autenticacao/resetar-senha`,
    cmd,
    {
      withCredentials: true,
      timeout: 120000,
    },
  );
  return response.data;
}

export const useStore = defineStore('resetar-senha', {
  state: () => ({
    status: null,
    error: null,
    senha: null,
  }),
  actions: {
    async resetarSenha(token) {
      this.status = 'loading';
      try {
        await resetarSenha({
          token,
          senha: this.senha,
        });
        this.status = 'success';
      }
      catch (e) {
        this.error = error(e).error;
        this.status = 'error';
      }
    },
  },
});
